import { type ConfigItem, FactSetWidget } from "./FactsetWidget";

export type NewsDetailProps = {
  identifier: string;
  symbolLinkClick?: (event: any) => void;
  className?: string;
  ariaLevel?: "2" | "3" | "4" | "5" | "6";
};

export function NewsDetail({
  identifier,
  symbolLinkClick,
  className,
  ariaLevel,
}: NewsDetailProps) {
  const config = [
    { type: "attribute", key: "identifier", value: identifier },
    { type: "attribute", key: "identifierEmitted", value: "tickerRegion" },
  ] as ConfigItem[];

  if (ariaLevel) {
    config.push({
      type: "attribute",
      key: "baseAriaLevel",
      value: ariaLevel,
    });
  }

  if (symbolLinkClick) {
    config.push({
      type: "event",
      key: "row-click",
      value: symbolLinkClick,
    });
  }
  return (
    <FactSetWidget className={className} config={config} widget="news-detail" />
  );
}
